import { useResources } from 'datx-jsonapi-react';
import { ThinProfile } from '@/resources/ThinProfile';
import { queryThinProfilesByUserId } from '@/queries/thin-profiles';
import { queryProfilePlaylists } from '@/queries/profile-playlists';
import useSession from '@/hooks/useSession';
import { Flex, Skeleton } from '@chakra-ui/react';
import { DeletePlaylistModal } from '@/components/ui/features/lecture/BookmarkLectureModal/components/DeletePlaylistModal';
import { FC, useState } from 'react';
import { queryLecturePlaylists } from '@/queries/lecture-playlist';
import { PlaylistItem } from '@/components/ui/features/lecture/BookmarkLectureModal/components/PlaylistItem';
import { WatchlistItem } from '@/components/ui/features/lecture/BookmarkLectureModal/components/WatchlistItem';
import { WATCHLIST_NAME } from '@/components/ui/features/lecture/BookmarkLectureModal/constants';

export const PlaylistsList: FC<{ lectureId: string }> = ({ lectureId }) => {
  const { user } = useSession();
  const [deletePlaylistId, setDeletePlaylistId] = useState(null);

  const { data } = useResources<ThinProfile>(queryThinProfilesByUserId(user?.id));
  const { data: profilePlaylists } = useResources(queryProfilePlaylists(data?.[0]?.id));
  const { data: lecturePlaylists } = useResources(queryLecturePlaylists(data?.[0]?.id, { lecture_id: lectureId }));

  const excludedWatchlist = profilePlaylists?.filter((pp) => pp.name !== WATCHLIST_NAME);

  if (!lecturePlaylists) return <Skeleton />;

  return (
    <Flex h={{ base: '100%', lg: '300px' }} pr="2" overflowY="scroll" flexDirection="column">
      <WatchlistItem h="40px" mt={8} lectureId={lectureId} />
      {excludedWatchlist.map((pp) => (
        <PlaylistItem key={pp.id} lectureId={lectureId} playlist={pp} deletePlaylist={setDeletePlaylistId} />
      ))}
      <DeletePlaylistModal playlistId={deletePlaylistId} onClose={() => setDeletePlaylistId(null)} />
    </Flex>
  );
};
